import { isFunction } from '../../utils';
import * as ruleFuns from '../../utils/rules';
/**
 * @description: 提供表单验证
 * @param {*} value 输入框值
 * @param {*} props useFormItemParams
 */
export default function validate(input) {
    var _a;
    var rules = input.rules;
    var rulesLen = (rules === null || rules === void 0 ? void 0 : rules.length) || 0;
    if (rulesLen === 0) {
        return undefined;
    }
    for (var i = 0; i < rulesLen; i++) {
        var rule = rules[i];
        if (isFunction(rule)) {
            var error = rule(input);
            if (error) {
                return error;
            }
        }
        if (typeof rule === 'object') {
            var message = rule.message, type = rule.type;
            var validateFn = ruleFuns === null || ruleFuns === void 0 ? void 0 : ruleFuns[type];
            var error = (_a = validateFn === null || validateFn === void 0 ? void 0 : validateFn(message)) === null || _a === void 0 ? void 0 : _a(input);
            if (error !== undefined) {
                return error;
            }
        }
    }
    return undefined;
}
